export default __webpack_public_path__ + "6474fa54031a832ea58e706f040bac5f.png";